const Colors = {
  background: "#111111",
  text: "#ffffff",
  section: "#f5f5f5",
  sectionColor: "#111111",
};

export default Colors;
